import {
  SearchPageForm,
  type SearchPageFormProps,
} from 'components/GetRecruited/SearchPage/Form';

import styles from './SearchPage.module.scss';

export interface SearchPageProps extends SearchPageFormProps {}

export const SearchPage = ({
  profileData,
  profileResults,
  sports,
}: SearchPageProps) => {
  return (
    <div className={styles.block}>
      <div className={styles.container}>
        <SearchPageForm
          profileData={profileData}
          profileResults={profileResults}
          sports={sports}
        />
      </div>
    </div>
  );
};
